import { Col, Row } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { SearchPixelStrap } from "../../../../Constants/Constants";
import { SearchInformation, SearchTabData } from "../../../../Data/Applications/SearchResult/SearchResult";
import PagesSort from "./Pages";
import InformationCommon from "./common/InformationCommon";

const AllTabs = () => {
  return (
    <>
      <H6 className="mb-2">{SearchPixelStrap}</H6>
      <Row>
        <Col xxl="6" xl="6" className="box-col-12">
          {SearchTabData.map((item, i) => (
            <InformationCommon item={item} key={i} />
          ))}
        </Col>
        <Col xxl="6" xl="6" className="box-col-12">
          {SearchInformation.map((item, i) => (
            <InformationCommon item={item} key={i} />
          ))}
        </Col>
      </Row>
      <PagesSort pageClass="end" />
    </>
  );
};
export default AllTabs;
